<mat-expansion-panel [(expanded)]="openedPanel" class="mat-elevation-z0" [style]="{'background-color': '#F3F4F6' }">
  <mat-expansion-panel-header>
    {{ title }}
  </mat-expansion-panel-header>
  <form [formGroup]="form">
    <div class="controls">
      @for (item of _items; track item.id) {
        <div class="control" [class.active]="value?.id === item.id">
          <input type="radio" [formControlName]="'value'" [value]="item" name="value" />
<!--          <span>{{ item.name }}</span>-->
          <ng-container *ngTemplateOutlet="name; context: {$implicit: item}"></ng-container>
        </div>
      }
    </div>
  </form>
</mat-expansion-panel>
